<template>
    <div class="sigleproduct">
		<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <CommonHead></CommonHead>       
        <b-modal
        id="cart_notificaion"
        ref="cartmodal"
        :title="this.cartOrderMsg"
        title-tag="h3"
        ok-only
        modal-class="common_pop cart_notificaion">
        </b-modal>
	
        <!-- Save to projects pop up -->
        <b-modal
            id="saveto-project"
            ref="modal"
            title="Save to Projects"
            title-tag="h3"
            ok-only
            modal-class="common_pop saveto_project">
            <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
                <h3>Save to Projects</h3>
                <ul>
                    <li><a href="javascript:;" @click="showclient = !showclient">Existing Client - Existing Project</a></li>
                    <li><a href="javascript:;" @click="shownewproject = !shownewproject">Existing Client - New Project</a></li>
                    <li><a href="javascript:;" @click="shownewclient = !shownewclient">New Client- New Project</a></li>
                </ul>
            </div>
                <div v-if="showclient" class="savetoclient">
                    <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to Existing Client- Project</h3>
					<b-form class="commonform" @submit="Submit1Popup">
						<div class="row">
						  <div class="col" :state="!form1.errors.has('client')" :class="form1.errors.get('client')?'haserror forstar':'forstar'"
                            :invalid-feedback="form1.errors.get('client')">
							<label class="setuplabel">Select a Client</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form1.errors.has('client')"
                                @input="form1.errors.clear('client'); getProjects();"
								:options="clientscart"
								:reduce="clientscart => clientscart.value"
								label="text"
										v-model="form1.client"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
							</div>
						  </div>
						</div>
						<div class="row showProject">
						  <div class="col" :state="!form1.errors.has('project')" :class="form1.errors.get('project')?'haserror forstar':'forstar'"
                            :invalid-feedback="form1.errors.get('project')">
							<label class="setuplabel">Select a Project</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form1.errors.has('project')"
                                @input="form1.errors.clear('project')" :options="projects"
								:reduce="projects => projects.value"
								label="text"
										v-model="form1.project"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
							</div>
						  </div>
						</div>
                    <b-button block type="submit" variant="dark">Add</b-button>
					<span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
					</b-form>
                </div>
                <div v-if="shownewproject" class="savetoclient">
                    <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to New Project of Existing Client</h3>
					<b-form class="commonform" @submit="Submit2Popup">
						<div class="row">
						  <div class="col" :state="!form2.errors.has('client_id')" :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
                            :invalid-feedback="form2.errors.get('client_id')">
							<label class="setuplabel">Select a Client</label>
							<div class="md-field md-theme-default">
							<v-select :state="!form2.errors.has('client_id')"
                                @input="form2.errors.clear('client_id'); showProject1();" :options="clientscart"
								:reduce="clientscart => clientscart.value"
								label="text"
										v-model="form2.client_id"
										placeholder="">
							</v-select>
							<span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
							</div>
						  </div>
						</div>
						<div class="row showProject1">
						  <div class="col">
							<md-field :state="!form2.errors.has('name')" :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                            :invalid-feedback="form2.errors.get('name')">
							<label class="setuplabel">Create and save to new project</label>
							<md-input :state="!form2.errors.has('name')"
                                @input="form2.errors.clear('name')" v-model="form2.name"></md-input>
							
							<span class="error-msg" v-if="form2.errors.get('name')">{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
						  </md-field>
						  </div>
						</div>
						<b-button block type="submit" variant="dark">Add</b-button>
						<span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
					</b-form>
                </div>
                <div v-if="shownewclient" class="savetoclient newcreation">
                    <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;"><b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back</a>
                    <h3>Save to New Client- Project</h3>
                    <b-form class="commonform" @submit="Submit3Popup">
                        <md-field :state="!form.errors.has('createclient')" :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
                            :invalid-feedback="form.errors.get('createclient')">
                            <label>Create a new client</label>
                            <md-input :state="!form.errors.has('createclient')"
                                @input="form.errors.clear('createclient'); showProject2();" v-model="form.createclient"></md-input>
							<span class="error-msg" v-if="form.errors.get('createclient')">{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
						</md-field>
                        <md-field :state="!form.errors.has('createproject')" :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
                            :invalid-feedback="form.errors.get('createproject')">
                            <label>Create a new project</label>
                            <md-input :state="!form.errors.has('createproject')"
                                @input="form.errors.clear('createproject')" v-model="form.createproject"></md-input>
							<span class="error-msg" v-if="form.errors.get('createproject')">{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
                        </md-field>
                        <b-button block type="submit" variant="dark">Add</b-button>
						<span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
                    </b-form>
                </div>
        </b-modal>
		
		<b-modal
		  id="success-save-project"
		  ref="successmodal"
		  :title="this.successtitle"
		  title-tag="h3"
		  ok-only
		  modal-class="common_pop save_project"
		>
		</b-modal>
		<div class="basestyle-backdrop bg-dark" v-if="basestyleshow == true" @click="closeBaseFabrics"></div>
		<div class="basestylecontainer" v-if="basestyleshow == true">
		<div class="row my-5">
			<h3 class="mx-auto pl-65 basecotainertitle">Select a Fabric</h3>
			<b-img
			class="mr-5 basestylecontainer-close-icon"
			src="/shop/images/close.svg"
			fluid
			alt="close image"
			@click="closeBaseFabrics"
			></b-img>
		</div>
		<perfect-scrollbar :suppressScrollX="false">
			<SKLoader :repeat="5" :loading="isLoadingBase" speed="1s" class="baseloadercont">
			<SKBaseFabrics/>
			</SKLoader>
			<template v-if="baseFabrics.length > 0 && isLoadingBase == false">
			<template v-for="(baseFabric, i) in baseFabrics" :key="i">
				<div class="p-3">
				<div class="row mb-5">
					<div class="col-5">
					<b-img :src="baseFabric.URL" fluid></b-img>
					</div>
					<div class="col-7">
					<h3 class="text-left mb-3 basefabricname">
						{{ baseFabric.NAME }}
					</h3>
					<p>Price: 
						<span class="font-weight-normal">
						$ {{ parseFloat(baseFabric.AMOUNT).toFixed(2) }} / per yd
						</span>
					</p>
					<p class="basefabricdescrip">{{ baseFabric.RMC_BaseFabricDesc }}</p>
					<hr>
					<div class="accordion">
						<a class="text-decoration-none" href="javascript:;" v-b-toggle="'collapse-' + i">
						Specifications
						</a>
						<div class="specification mt-3">
						<div class="spec_cont">
							<div class="spec_details">
							<div class="lblspec">
								<span>Width:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.RMC_BaseFabricWidth != '' ? parseFloat(baseFabric.RMC_BaseFabricWidth).toFixed(2) : "-" }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Weight:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.RMC_BaseFabricWeight != '' ? parseFloat(baseFabric.RMC_BaseFabricWeight).toFixed(2) : '' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Content:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.RMC_BaseFabricContent != '' ? baseFabric.RMC_BaseFabricContent : '-' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Country:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.LogisticsAddressCountryRegionId != '' ? baseFabric.LogisticsAddressCountryRegionId : '-' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Wyzenbeek:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.RMC_BaseFabricWyzenbeek != '' ? baseFabric.RMC_BaseFabricWyzenbeek : '-' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Martindale:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.RMC_BaseFabricMartindale != '' ? baseFabric.RMC_BaseFabricMartindale : '-' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>CleaningCode:</span>
							</div>
							<div class="txtspec">
								<p>{{ baseFabric.CleaningCode != '' ? baseFabric.CleaningCode : '-' }}</p>
							</div>
							</div>
							<div class="spec_details">
							<div class="lblspec">
								<span>Test Code:</span>
							</div>
							<div class="txtspec">
								<p>
								{{ baseFabric.rmcFireTestCode1 != '' ? baseFabric.rmcFireTestCode1 : '-' }},
								{{ baseFabric.rmcFireTestCode2 != '' ? baseFabric.rmcFireTestCode2 : '-' }},
								{{ baseFabric.rmcFireTestCode3 != '' ? baseFabric.rmcFireTestCode3 : '-' }}
								</p>
							</div>
							</div>
						</div>
						</div>
					</div>
					<hr>
					<button class="btn btn btn-outline-primary fabricSelectBtn" @click="baseFabricSelected(baseFabric)">SELECT</button>
					</div>
				</div>
				<hr>
				</div>
			</template>
			</template>
			<template v-else>
			<div class="text-center">
				<h3 class="mt-5">No Fabric Found. </h3>
			</div>
			</template>
		</perfect-scrollbar>
		</div>
		<div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
			<SKLoader
				:repeat="1"
				:loading="isLoading"
				speed="1s"
				>
				<SKProductDetails/>
			</SKLoader>
            <div class="singleproductdetails">
				<div class="mobile-title">
					 <h2>{{info.ITEMNAME?info.ITEMNAME:''}}</h2>
					<a v-if="user.id > 0" class="printdetails" @click="getPDF()" href="javascript:;">
						<b-img class="print" src="/shop/images/print.svg" fluid alt="print image"></b-img>Print Details
					</a>
				</div>
                <div class="singleimage">
                    <div class="positionset">
                        <div class="highlight">
							<vue-magnifier :src="info.SRCSMALL" :src-large="info.SRCLARGE" />
                            <a :href="info.SRCLARGE" :download="info.ITEMNAME+'.jpg'" class="downloadimg" v-b-tooltip.hover title="Download Image">
								<b-img class="download" src="/shop/images/download.svg" fluid alt="download image"></b-img>
							</a>
                        </div>
                        <div class="smallimages" v-if="info.PRODUCTIMAGES.length > 1">
                            <a v-for="(proimg,pik) in info.PRODUCTIMAGES" :key="pik" href="javascript:;" class="forborder"><b-img class="smallimg" :src="proimg.MEDIUM_IMAGE" fluid alt="product6 image"></b-img></a>
                        </div>
                    </div>
                </div>
                <div class="singlecontent">
                    <h2>{{info.ITEMNAME?info.ITEMNAME:''}}</h2>
                    <a v-if="user.id > 0" class="printdetails" @click="getPDF()" href="javascript:;"><b-img class="print" src="/shop/images/print.svg" fluid alt="print image"></b-img>Print Details</a>
                    <div class="pricesection" v-if="user.id > 0 && info.basefabricbox == false">
                        <div class="samediv">
                            <span>Wholesale Price :</span>
							<div v-if="info.DISCOUNTPRICE > 0 && info.CUSTOMERDISCOUNT == false">
								<p
								class="regprice"
								>$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
								<span
								class="saleprice"
								>$ {{parseFloat(info.DISCOUNTPRICE).toFixed(2)}} / {{info.UNITID}}</span>
							</div>
							<p v-else-if="info.DISCOUNTPRICE == 0">$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
							<p v-else-if="info.CUSTOMERDISCOUNT == true">$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
                        </div>
                        <div class="samediv" v-if="info.SUNTAFITEMSTATUS != 'DropShip'">
							<span>Qty on Hand :</span>
							<p>{{info.QtyOnHand}} EA</p>
						</div>
                    </div>
					<div class="pricesection" v-if="user.id > 0 && info.basefabricbox == true"> 
						<div class="samediv">
							<span>Retail Price :</span>
							<p>$ {{ computedPrice(2) }} / EA</p>
						</div>
						<div class="samediv" v-if="user.setting_retail === false">
							<span>Wholesale Price :</span>
							<p>$ {{ computedPrice() }} / EA</p>
						</div>
					</div> 
					<div class="detailed-options">
						<ul class="new_ul">
							<li v-if="info.LONGDESCRIPTION"><a href="javascript:;" v-b-toggle.descriptioncont>Description <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
								<b-collapse id="descriptioncont" visible accordion="my-accordion_descriptioncont">
									<div class="specification">
													<div class="spec_cont">
										<div class="spec_details">
										<div class="txtspec w-100"><p>{{info.LONGDESCRIPTION}}</p></div>
													</div>
													</div>
									</div>
								</b-collapse>
							</li>
							<li v-if="user.id > 0"><a href="javascript:;" v-b-toggle.specifications>Specifications <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
								<b-collapse visible id="specifications" accordion="my-accordion">
									<div class="specification">
										<div class="spec_cont">
											<div class="spec_details">
												<div class="lblspec"><span>ITEMID:</span></div>
												<div class="txtspec"><p>{{info.ITEMID}}</p></div>
											</div>
										</div>
									</div>
								</b-collapse>
							</li>
							<li class="diff_li">
					<div class="fixedbar">
						  <div class="container">
							<div class="beforesignin" v-if="user.id<=0">
							  <h3>To place orders please sign in or register</h3>
							  <div class="buttonsdiv">
								  <b-button href="/shop/login" variant="dark">Sign in</b-button>
								  <b-button href="/apply/" variant="dark">Register</b-button>
							  </div>
							</div>
							<b-form class="addcartform commonform" @submit="onSubmit" v-if="user.id >0">
							  
							  <div class="afterlogin">
							  <p v-if="info.basefabricbox == false && info.SUNTAFITEMSTATUS != 'DropShip'" :class="info.QtyOnHand>1?'noti_msg HideNoti':'noti_msg'">Your order will be backordered due the quantity on hand. See Available Bolts for details.</p>
								<div class="samediv quantity">
								  <div class="qtydiv">
									<span @click="decrement()">-</span>
									<input v-model.number="cartform.quantity" type="number" @input="handleInput" :readonly="info.basefabricbox == true" step=".01"/>
									<span @click="increment()" class="lastspan">+</span>
								  </div>
								</div>
								<div class="ordertype yard">
								  <v-select 
									:options="yard"
									v-model="cartform.unitid"
									:clearable="false"
									:searchable="false"
									placeholder="yd"
								></v-select>
								</div>
								<div :class="basefabricname != '' ? 'base-container mt43' : 'base-container'">
									<div class="requiredcut bsbox" v-if="user.id > 0">
										<input v-if="info.basefabricbox == true" :disabled="cartform.order_type == ''" class="basestyle" type="text" :value="basefabricname" readonly @click="getBaseFabrics" placeholder="Please Select Base Fabric" />
										<span v-if="info.basefabricbox == true" class="error-msg basestyle-error d-none">Required Field</span>
										<img v-if="info.basefabricbox == true" src="/shop/images/edit.svg" alt="Edit image" class="edit-alt" @click="getBaseFabrics">
									</div>
									<div class="requiredcut basefabricimg" v-if="basefabricname != ''">
										<img :src="basefabricimage" alt="Edit image" class="img-fluid">
									</div>
								</div>
								<div class="barbuttons">
								<input type="hidden" v-model="cartform.user_id">
								<input type="hidden" v-model="cartform.itemid">
								<input type="hidden" v-model="cartform.pc_type">
								<input type="hidden" v-model="cartform.order_type">
								  <b-button type="submit" class="AddTOCartBtn" variant="dark" :disabled="isAddToCartDisabled(info)">Add to cart</b-button>
								  <b-button @click="Showsavetoproject" variant="outline-primary" v-if="info.basefabricbox == false" :disabled="isAddToCartDisabled(info)">
									<b-img class="saveproject" src="/shop/images/bookmark.svg" fluid alt="save image"></b-img>
									<b-img
									  class="saveproject white"
									  src="/shop/images/bookmark-white.svg"
									  fluid
									  alt="save image"
									></b-img>Save to Projects
								  </b-button>
								</div>
							  </div>
							</b-form>
						  </div>
						</div>
				</li>
						</ul>
					</div>
                    
                    <div class="specification">
                        <div class="shareus">
                            <p>Share: </p>
                            <ul>
                                <li>
                                    <a :href="facebookshare" target="_blank">
                                        <b-img class="social_icon" alt="facebook" src="/shop/images/facebook.svg"></b-img>
                                    </a>
                                </li>
                                <li>
                                    <a :href="pintrestshare" target="_blank">
                                        <b-img class="social_icon" alt="pinterest" src="/shop/images/pinterest.svg"></b-img>
                                    </a>
                                </li>
                                <li>
                                    <a :href="houzzshare" target="_blank">
                                        <b-img class="social_icon" alt="houzz" src="/shop/images/houzz.svg"></b-img>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="needhelp">
							<h3>Need Help?</h3>
							<div class="callwrite">
								<div class="callus">
								<h4>Call Us</h4>
								<a href="#">
									<b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
								</a>
								<span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
								</div>
								<div class="writeus">
								<h4>Write to Us</h4>
								<a href="mailto:customerservice@rmcoco.com">
									<b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
								</a>
								<span>We’ll get back to you within 24 hours.</span>
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import vueMagnifier from "@/components/vue-magnifier";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKProductDetails from "@/views/skeletons/SKProductDetails";
import SKBaseFabrics from "@/views/skeletons/SKBaseFabrics";

export default {
  components: {
    CommonHead,
    CommonFoot,
    vueMagnifier,
	VueSlickCarousel,
	SKProductDetails,
	SKBaseFabrics,
	'v-select': vSelect,
	Loading
  },
  mounted() {
	  this.isLoading = true;
      this.$store.dispatch("loadSampleProductInfo",{itemid:encodeURI(this.$route.params.itemid)}).then(productdetails => {
		  this.productdetails = productdetails;
		  this.info.SRCSMALL = this.productdetails.PRODUCTIMAGES[0].LARGE_IMAGE;
		  this.info.SRCLARGE = this.productdetails.PRODUCTIMAGES[0].ORIGINAL_IMAGE;
		  this.info.PRODUCTIMAGES = this.productdetails.PRODUCTIMAGES;
		  this.info.ITEMNAME = this.productdetails.ITEMNAME;
		  this.info.PRICE = this.productdetails.PRICE;
		  this.info.DISCOUNTPRICE = this.productdetails.DISCOUNTPRICE;
		  this.info.CUSTOMERDISCOUNT = this.productdetails.CUSTOMERDISCOUNT;
		  this.info.QtyOnHand = this.productdetails.QtyOnHand;
		  this.info.SUNTAFCLASSVALUE = this.productdetails.SUNTAFCLASSVALUE;
		  this.info.SUNTAFITEMSTATUS = this.productdetails.SUNTAFITEMSTATUS;
		  this.info.ITEMID = this.productdetails.ITEMID;
		  this.info.basefabricbox = this.productdetails.basefabricbox;
		  this.info.LONGDESCRIPTION = this.productdetails.LONGDESCRIPTION;
		  if(this.info.basefabricbox == true){
            this.info.MINPRICE = this.productdetails.MINPRICE;
            this.info.MAXPRICE = this.productdetails.MAXPRICE;
		  }

          this.pintrestshare = 'http://pinterest.com/pin/create/button/?url='+window.location.href+'&media=//'+window.location.hostname+this.info.SRCLARGE+'&description='+productdetails.ITEMNAME;
		  this.houzzshare = 'https://www.houzz.com/imageClipperUpload?link=//'+window.location.hostname+this.info.SRCLARGE+'&source=button&hzid=36769&title='+productdetails.ITEMNAME+'&ref='+window.location.href;
		  this.breadcrumb[1].text = "All "+productdetails.PC_TYPE;
		  this.breadcrumb[1].href = "/shop/products/"+productdetails.PC_TYPE.toLowerCase();
		  this.breadcrumb[2].text = productdetails.ITEMNAME;
		  this.isLoading = false;
  
		  // set meta title
		
		var metaTitle="RM COCO | "+this.productdetails.ITEMNAME+" - Product Sample";
		var metaDesc="This "+this.productdetails.ITEMNAME+" product sample is available exclusively at RMCOCO.com.";
		
		document.title=metaTitle;
		$('meta[name="description"]').remove();
		$('head').append('<meta name="description" content="'+metaDesc+'">');
		this.getProductBaseFabricsRegular();
		
      });
	  if (this.user.id > 0) {
	  	this.LoadClients();
	  }
  },
  data(){
      return{
		cartOrderMsg:"",
		successtitle:"",
		info:{
			SRCSMALL:null,
			SRCLARGE:null,
			PRODUCTIMAGES:[],
			ITEMNAME:"",
			PRICE:null,
			DISCOUNTPRICE:null,
        	CUSTOMERDISCOUNT:null,
			MINPRICE:null,
			MAXPRICE:null,
			QtyOnHand:null,
			SUNTAFCLASSVALUE: "",
			SUNTAFITEMSTATUS: "",
			ITEMID:"",
			UNITID:"EA",
			LONGDESCRIPTION: "",
			basefabricbox:false
		},
		cartform: new Form({
            itemid: "",
			inventcolorid: "",
			pc_type: "",
			unitid:"ea",
            order_type: "regular",
            quantity:1,
			notes:"",
			user_id:"",
			basestyle:"",
			basefabricname: "",
			baseprice: 0,
			discountedprice: 0
        }),
        settings:{
            "dots": false,
            "focusOnSelect": true,
            "infinite": true,
            "speed": 500,
            "slidesToShow": 5,
            "slidesToScroll": 1,
            "touchThreshold": 1,
        },
        productdetails:[],
		form: new Form({
            createclient: "",
            createproject:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:"",
			quantity:"",
			user_id:'',
			cart: "",
			error_name: "",
			inventstyleid: "",
			basefabricname: ""
        }),
		form1: new Form({
            client: "",
            project:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:"",
			quantity:"",
			user_id:'',
			cart:'',
			error_name: "",
			inventstyleid: "",
			basefabricname: ""
        }),
		form2: new Form({
            client_id: "",
            name:"",
			product_id:"",
			inventcolorid:"",
			pc_type : "",
			order_type:"",
			notes:'',
			quantity:"",
			cart:'',
			user_id:'',
			error_name: "",
			inventstyleid: "",
			basefabricname: ""
        }),
        minicart:{
			items:[]
		},
		showclient:false,
        shownewproject:false,
        shownewclient:false,
        orderstype: [
            { value: 'regular', text: 'Regular'},
        ],
        yard: [
            'ea'
        ],
		clientscart: [
            { value: '1', text: 'James'},
            { value: '2', text: 'Mathew'},
           
        ],
        projects: [
            { value: '1', text: 'Lorem'},
            { value: '2', text: 'Ipsum'},
            
        ],
        saveprojectcart: [
            { value: '1', text: 'Lorem'},
            { value: '2', text: 'Ipsum'},
            
		],
		facebookshare:'https://www.facebook.com/sharer/sharer.php?u='+window.location.href,
		pintrestshare:'',
		houzzshare:'',
		previousPrice:null,
		isLoadingBase: false,
		basefabricimage:"",
		basestyleshow: false,
		baseFabrics: [],
		baseFabricsRegular: [],
		selectedBaseFabric: [],
        isLoading: false,
		breadcrumb: [
			{
				text: 'Home',
				href: '/'
			},
			{
				text: 'All Sample',
				href: '#'
			},
			{
				text: '',
				active: true
			}
        ]
      }
  },
  computed: {
    ...mapGetters(["user"]),
	basefabricname() {
		if (Object.keys(this.selectedBaseFabric).length > 0) {
			return this.selectedBaseFabric.NAME;
		}
		return '';
	}
  },
  hideModal() {
      this.$refs["modal"].hide();
    },
  methods:{
    getPDF(){
		this.$store.dispatch("loadProductsamplePDF",{itemid:this.$route.params.itemid}).then(response => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'product.pdf');
			document.body.appendChild(link);
			link.click();
				
		  });
	},
	onSubmit(evt) {
        evt.preventDefault();
        var submit=1;
        this.cartform.itemid = this.productdetails.ITEMID;
        this.cartform.pc_type = this.productdetails.PC_TYPE;
		this.cartform.inventcolorid = this.productdetails.INVENTCOLORID;
		this.cartform.user_id = this.user.accountnumber;
		if (Object.keys(this.selectedBaseFabric).length == 0) {
			this.cartform.baseprice = this.info.PRICE;
		}
		this.cartform.discountedprice = this.info.DISCOUNTPRICE;
		if(this.user.id > 0 && this.info.basefabricbox == true){
			if (Object.keys(this.selectedBaseFabric).length > 0) {
				$(".requiredcut > .basestyle").removeClass("border-danger");
				$(".basestyle-error").addClass('d-none');
			} else{
				submit = 0;
				$(".requiredcut > .basestyle").addClass("border-danger");
				$(".basestyle-error").removeClass('d-none');
				return false;
			}
		}
		if(submit==1){  
			this.isLoading = true; 
			this.$store
			.dispatch("AddtoCartSample", {
				form: this.cartform
			})
			.then(rsdata => {
				if(rsdata.data.success == false){
					this.cartOrderMsg = rsdata.data.message;
					this.$refs["cartmodal"].show();
					this.isLoading = false;
				}else{
					this.$notify({
						text: "Product added to cart",
						type: "success"
					});
					this.isLoading = true;
					this.$store.dispatch("loadCart",this.user.accountnumber).finally(() => {
						this.isLoading = false;
					});
				}
			})
			.catch(error => {
				if (this.cartform.hasErrors()) {
					this.$notify({
						text:
						"There is a validation error. Please correct the fields outlined in red and try again.",
						type: "error"
					});
				} else {
					this.$notify({
						text: "Something went wrong!",
						type: "error"
					});
				}
				this.isLoading = false;
			});
		}
    },
    increment () {
        let currentqty = Number(this.cartform.quantity) + 1;
      	this.cartform.quantity = Number(currentqty).toFixed(2);
		if (this.info.SUNTAFITEMSTATUS != 'DropShip') {
			if(this.productdetails.QtyOnHand < this.cartform.quantity){
				$(".noti_msg").removeClass("HideNoti");
			}else{
				$(".noti_msg").addClass("HideNoti");
			}
		}
	},
	handleInput(e){
		let stringValue = e.target.value.toString();
		let regex = /^\d*(\.\d{1,2})?$/
		if(!stringValue.match(regex) && this.cartform.quantity!== '') {
			this.cartform.quantity = this.previousPrice;
		}
		this.previousPrice = this.cartform.quantity;
		if (this.info.SUNTAFITEMSTATUS != 'DropShip') {
			if(this.productdetails.QtyOnHand<this.cartform.quantity){
				$(".noti_msg").removeClass("HideNoti");
			}else{
				$(".noti_msg").addClass("HideNoti");
			}
		}
    },
    decrement () {
      if(this.cartform.quantity < 1) {
        console.log('Negative quantity not allowed')
      } else {
        let currentqty = Number(this.cartform.quantity) - 1;
        this.cartform.quantity = Number(currentqty).toFixed(2);
		if (this.info.SUNTAFITEMSTATUS != 'DropShip') {
        	if(this.productdetails.QtyOnHand<this.cartform.quantity){
				$(".noti_msg").removeClass("HideNoti");
			}else{
				$(".noti_msg").addClass("HideNoti");
			}
		}
      }
    },
	Submit1Popup(evt) {
      evt.preventDefault();
	  
	  this.form1.product_id = this.productdetails.ITEMID;
	  this.form1.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form1.inventstyleid = this.cartform.basestyle;
      this.form1.basefabricname = this.cartform.basefabricname;
	  this.form1.pc_type = this.productdetails.PC_TYPE;
	  this.form1.order_type = this.cartform.order_type;
	  this.form1.notes=this.cartform.notes
	  this.form1.quantity = this.cartform.quantity;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddProductToProject", {
			form: this.form1
		  }).then(response => {
         if (response.data.success) {
		 this.form1.error_name="";
           this.$notify({
             text: "Product added successfully",
             type: "success"
           });
           this.form1 = new Form({
             client: null,
			 project: null,
			 error_name:'',
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		   this.form1.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
	Submit2Popup(evt) {
      evt.preventDefault();
	  
	  this.form2.product_id = this.productdetails.ITEMID;
	  this.form2.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form2.inventstyleid = this.cartform.basestyle;
      this.form2.basefabricname = this.cartform.basefabricname;
	  this.form2.pc_type = this.productdetails.PC_TYPE;
	  this.form2.order_type = this.cartform.order_type;
	  this.form2.notes=this.cartform.notes;
	  this.form2.quantity = this.cartform.quantity;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddProject", {
			form: this.form2
		  }).then(response => {
         if (response.data.success) {
		 this.form2.error_name="";
           this.$notify({
             text: "Project added successfully",
             type: "success"
           });
           this.form2 = new Form({
             client_id: null,
			 name: null,
			 error_name:''
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		   this.form2.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
	Submit3Popup(evt) {
      evt.preventDefault();
	  
	  this.form.product_id = this.productdetails.ITEMID;
	  this.form.inventcolorid = this.productdetails.INVENTCOLORID;
	  this.form.inventstyleid = this.cartform.basestyle;
      this.form.basefabricname = this.cartform.basefabricname;
	  this.form.pc_type = this.productdetails.PC_TYPE;
	  this.form.order_type = this.cartform.order_type;
	  this.form.notes=this.cartform.notes;
	  this.form.quantity = this.cartform.quantity;
	  this.form.user_id = this.user.accountnumber;
	  
	  this.isLoading = true;
       this.$store.dispatch("AddClientAndProject", {
			form: this.form
		  }).then(response => {
         if (response.data.success) {
			this.form.error_name="";
			//update clients dropdown
			this.LoadClients();
			
           this.$notify({
             text: "Product added successfully",
             type: "success"
           });
           this.form = new Form({
             createclient: null,
			 createproject: null,
			 error_name:'',
           });
		   
		   this.$refs["popupmodal"].hide();
		   this.successtitle="Product added successfully";
		   this.$refs["successmodal"].show();
		   
		   
         } else {
           this.$notify({
             text: "please try again!",
             type: "error"
           });
		    this.form.error_name=response.data.error;
         }
       });
       this.isLoading = false;
	},
	Showsavetoproject(){
		if(this.cartform.order_type){
			this.resetModelForm();
			this.$refs["modal"].show();
		}else{
			$(".ordertype.type").append("<span class='error-msg'>Required Field</span>");
		}
	},
	resetModelForm(){
		$(".ordertype.type .error-msg").remove();
		$(".savetoclient .error-msg").remove();
		this.showclient=false;
		this.shownewproject=false;
		this.shownewclient=false;
		//reset forms
		this.form.createclient= "";
		this.form.createproject="";
		this.form.product_id="";
		this.form.inventcolorid="";
		this.form.pc_type="";
		this.form.order_type="";
		this.form.notes="";
		this.form.quantity="";
		this.form.user_id='';
		this.form.cart='';
	
	
		this.form1.client= "";
		this.form1.project="";
		this.form1.product_id="";
		this.form1.inventcolorid="";
		this.form1.pc_type="";
		this.form1.order_type="";
		this.form1.notes="";
		this.form1.quantity="";
		this.form1.user_id='';
		this.form1.cart='';
	
		this.form2.client_id= "";
		this.form2.name="";
		this.form2.product_id="";
		this.form2.inventcolorid="";
		this.form2.pc_type="";
		this.form2.order_type="";
		this.form2.notes="";
		this.form2.quantity="";
		this.form2.user_id='';
		this.form2.cart='';
	},
	getProjects(){
		if(this.form1.client){
			$(".showProject").show();
			this.$store.dispatch("LoadClientProjects",this.form1.client).then(loadprojects => {
				  this.projects = loadprojects.data;
			  });
		}else{
			$(".showProject").hide();
		}
	},
	showProject1(){
		if(this.form2.client_id){
			$(".showProject1").show();
		}else{
			$(".showProject1").hide();
		}
	},
	showProject2(){
		if(this.form.createclient){
			$(".showProject2").show();
		}else{
			$(".showProject2").hide();
		}
	},
	LoadClients(){
		this.$store.dispatch("LoadClient",this.user.accountnumber).then(loadclients => {
			  this.clientscart = loadclients.data;
		});
	},
	getProductBaseFabricsRegular(){
      this.isLoadingBase = true;
      this.$store.dispatch('getProductBaseFabrics', {
        itemId: this.$route.params.itemid,
        inventColorId: "100",
      }).then(baseFabrics => {
        let data  = baseFabrics.data.sort(function(a, b){
          return a.AMOUNT - b.AMOUNT;
        });
        this.baseFabricsRegular = data;
        this.baseFabrics = this.baseFabricsRegular;
        this.isLoadingBase = false;
      });
	},
	getBaseFabrics(){
      this.baseFabrics = this.baseFabricsRegular;
      if(this.cartform.order_type != ""){
        this.basestyleshow = true;
      }
    },
    closeBaseFabrics() {
      this.basestyleshow = false;
    },
    baseFabricSelected(fabric) {
      $(".requiredcut > .basestyle").removeClass("border-danger");
      $(".basestyle-error").addClass('d-none');
      this.selectedBaseFabric = fabric;
      this.basestyleshow = false;
      this.cartform.basestyle = fabric.INVENTSTYLEID;
      this.cartform.baseprice = fabric.AMOUNT;
      this.cartform.basefabricname = fabric.NAME;
      this.basefabricimage = fabric.URL;
	},
	computedPrice(multi = 1) {
      let price = '';
      if (Object.keys(this.selectedBaseFabric).length > 0) {
        price = parseFloat(this.selectedBaseFabric.AMOUNT * multi).toFixed(2);
      } else {
        price = `${parseFloat(this.info.MINPRICE * multi).toFixed(2).toString()} - $ ${parseFloat(this.info.MAXPRICE * multi).toFixed(2).toString()}`;
      }
      return price;
    },
	isAddToCartDisabled(d) {
		return (d?.SUNTAFCLASSVALUE?.includes('SM-FABR-') && Number(d?.QtyOnHand) < 1);
	}
  }
}
</script>
<style scoped>
.base-container{
	display: flex;
	width: 100%;
	align-items: flex-end;
}
.base-container.mt43{
	margin-top: -43px;
	z-index: 0;
}
.singlecontent .fixedbar .requiredcut.basefabricimg{
	margin-top: 0px;
}
.sigleproduct .fixedbar .samediv.quantity,.sigleproduct .fixedbar .ordertype.yard{
	z-index: 1;
}
.sigleproduct .fixedbar .requiredcut input.basestyle,.sigleproduct .fixedbar .requiredcut.bsbox svg, .sigleproduct .fixedbar .requiredcut.bsbox img.edit-alt{
	cursor: pointer;
}
</style>